/**
 * Make the tabs show the active panel
 */
document.addEventListener('DOMContentLoaded', function() {
    let tabContainers = document.querySelectorAll('.tabbed-view');
    if(!tabContainers) return;

    tabContainers.forEach((tabContainer) => {
        let tabSelectors = tabContainer.querySelectorAll('.tab-selector');
        let tabPanels = tabContainer.querySelectorAll('.tab-panel');

        tabSelectors.forEach((selector) => {
            selector.addEventListener('click', function() {
                let targetID = selector.getAttribute('id');
                
                tabSelectors.forEach((tsel) => {
                    tsel.classList.remove('active');
                })
                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                });

                selector.classList.toggle('active');
                tabContainer.querySelector(`.tab-panel[data-target="${targetID}"]`).classList.toggle('active');
            });
        });
    });
});


/**
 * Swiper for the sub-page/subsection listing
 */
const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: false,
    slidesPerView: 'auto',
    slidesPerViewAutoSlideSize: 300,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    freeMode: true,
    navigation: {
        nextEl: '.swiper-pagination .next',
        prevEl: '.swiper-pagination .prev',
    },
});


/**
 * Resize observer for managing the display of tabs that
 * flow across multiple lines
 */
function checkTabWrapping(container) {
    if (!container) return false;

    const children = [...container.children];
    if (children.length === 0) return false;

    // First row’s top offset
    const firstRowTop = children[0].offsetTop;

    // If any child is below the first row, wrapping occurred
    return children.some(el => el.offsetTop > firstRowTop);
}

function updateTabsLayout(container) {
    if (!container) return;

    const wrapped = checkTabWrapping(container);
    container.classList.toggle('tabs-wrapped', wrapped);

    if(wrapped && !container.classList.contains('tabs-wrapped')) {
        container.classList.add('tabs-wrapped');
    }
}

const containers = document.querySelectorAll('.tabbed-selectors');
containers.forEach((container) => {
    if (container) {
        const ro = new ResizeObserver(() => updateTabsLayout(container));
        ro.observe(container);
    }
});